import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import { signIn } from 'aws-amplify/auth';
import './Login.scss';
import giggLogo from '../../../images/gigg-logo.svg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isUserAuthorized, setPageTitle } from '../../../utils/Utils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import variables from '../../../styles/variables.module.scss';

type FieldType = {
  username: string;
  password: string;
};

type ErrorType = {
  name: string;
  message: string;
}

// TODO: Add back in full validation and errors

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm()
  const [error, setError] = useState<ErrorType | undefined>()
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkAuthorization = async () => {
      const isLoggedIn = await isUserAuthorized();

      if (isLoggedIn) {
        navigate('/');
      }
    };

    checkAuthorization();
  }, []);

  useEffect(() => {
    setPageTitle('Register');
  }, []);

  const handleFinish = async (values: FieldType) => {
    const { username, password } = values;
    try {
      setLoading(true);
      await signIn({ username, password });

      if (location.state?.from) {
        navigate(location.state.from);
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(err as ErrorType)
      message.error((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-container justify-center router-wrapper padding-bottom-lg">
      <div className="login-outer">
        <div className="flex-container justify-center">
          <div className="margin-bottom-md">
            <div className="login-image-container">
              <img className="login-img" src={giggLogo} height="auto" width="100%" alt="Gigg" />
            </div>
            <div className="flex-container justify-center">Welcome back! Sign In</div>
          </div>
        </div>
        <div className="login-inner">
          <Form layout="vertical" className="login-form" onFinish={handleFinish} form={form}>
          <Form.Item<FieldType> 
              name="username"
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email'
                },
                {
                  required: true,
                  message: 'Please input your Email'
                }
              ]}
            >
              <Input className="login-input" placeholder="Email" />
            </Form.Item>
            <Form.Item<FieldType> 
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input yout current password'
                }
              ]}
            >
              <Input.Password className="login-input" placeholder="Password" />
            </Form.Item>
            {
              error
              ? <p style={{textAlign: 'center', color: '#ff4d4f' }}>{error.message}</p>
              : null
            }
            <div className="flex-container margin-bottom-md">
              <div className="flex-container flex">
                <Button className="login-button" htmlType="submit" loading={loading}>
                  <span>Sign In</span>
                </Button>
              </div>
            </div>
          </Form>
          <div className="flex-container justify-space-between">
            <Link to="/forgot" className="login-link">
              Forgot your password?
            </Link>
            <div className="signup-cta">
              Don't have an account?{' '}
              <Link to="/register" className="login-link">
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
